import { render } from "./AppInstances.vue?vue&type=template&id=5606f9ec&scoped=true"
import script from "./AppInstances.vue?vue&type=script&lang=ts"
export * from "./AppInstances.vue?vue&type=script&lang=ts"

import "./AppInstances.vue?vue&type=style&index=0&id=5606f9ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5606f9ec"

export default script